import { el } from "./dom";
import { createDivider } from "./Divider";

export interface MenuHeaderOptions {
  readonly title: string;
}

export function createMenuHeader(opts: MenuHeaderOptions): HTMLElement {
  // h2 instead of a div so screen-reader users can jump screen-by-screen with
  // the H shortcut. The page itself has no h1 (SPA shell — the canvas/menu is
  // the whole document), so each screen's title sits at h2.
  return el("header", { class: "menu-subtitle" }, [
    el("h2", { class: "menu-subtitle__title", text: opts.title }),
    el("div", { class: "menu-subtitle__divider" }, [createDivider()]),
  ]);
}
